import { cloneRgObject } from './clone-rg-object.js';
import { deepNewUuid } from './deep-new-uuid.js';

function createFromTemplate(template) {
    const obj = deepNewUuid(cloneRgObject(template));
    obj.templateUuid = template.uuid;
    return obj;
}

export { createFromTemplate };
//# sourceMappingURL=rg-template.js.map
